
export const validatePassword = (password) => {
    const minLength = password.length >= 8;
    const hasUppercase = /[A-Z]/.test(password); // Pelo menos 1 letra maiúscula
    const hasLowercase = /[a-z]/.test(password); // Pelo menos 1 letra minúscula
    const hasNumber = /\d/.test(password);       // Pelo menos 1 número
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password); // Pelo menos 1 caractere especial

    let passwordValidationMessage = [];

    if (!minLength) {
        passwordValidationMessage.push("Ao menos 8 caracteres");
    }
    if (!hasUppercase) {
        passwordValidationMessage.push("Ao menos 1 letra maiúscula");
    }
    if (!hasLowercase) {
        passwordValidationMessage.push("Ao menos 1 letra minúscula");
    }
    if (!hasNumber) {
        passwordValidationMessage.push("Ao menos 1 número");
    }
    if (!hasSpecialChar) {
        passwordValidationMessage.push("Ao menos 1 caractere especial");
    }

    if (passwordValidationMessage.length > 0) {
        return {
            isValid: false,
            message: `A senha deve possuir:<br>- ${passwordValidationMessage.join("<br>- ")}`
        };
    }

    return { isValid: true, message: "Senha válida" };
};